import axios from "axios";
import { baseUrl } from "../constants";

const axiosClient = axios.create({
  baseURL: baseUrl,
  timeout: 3000,
});

export { axiosClient };
